(function ($) {
  'use strict';

  /**
   * Global Site Scripts
   * ===
   */

  // Fixs button icon positioning when text wraps to new line
  var $icon_buttons = $('.wp-element-button, .menu-item-button > a, .has-new-tab-icon');
  $icon_buttons.wrapInner( '<span></span>' );


  /**
   * Accordion Controls
   */

  $('.js-accordion').each(function () {
    $(this).accordionControls();
  });


  /**
   * Section Helpers
   */

  // SEO - Delete empty section headers & footers
  // - Prevents empty heading tags from showing up in SEO crawls.
  $('.is-header-disabled').find( '> .section-header' ).remove();
  $('.is-header-disabled').find( '> .wrap > .section-header' ).remove();
  $('.is-footer-disabled').find( '> .section-footer' ).remove();
  $('.is-footer-disabled').find( '> .wrap > .section-footer' ).remove();

  // SEO & a11y - Add aria rols for spoofed heading tags
  // - Useful for fake headings in the site header & footer, or elements above the main h1.
  $( 'p.h2' ).attr( 'role', 'heading' ).attr( 'aria-level', '2' );
  $( 'p.h3' ).attr( 'role', 'heading' ).attr( 'aria-level', '3' );
  $( 'p.h4' ).attr( 'role', 'heading' ).attr( 'aria-level', '4' );
  $( 'p.h5' ).attr( 'role', 'heading' ).attr( 'aria-level', '5' );
  $( 'p.h6' ).attr( 'role', 'heading' ).attr( 'aria-level', '6' );

})(jQuery);
